<template>
    <div class="app-footer" >
<!--        <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">工业和信息化部备案管理系统网站-->
<!--            粤ICP备2020094355号</a></p>-->
    </div>
</template>

<script>
    export default {
        name: "AppFooter",
    }
</script>

<style lang="scss" scoped>
    .app-footer {
        margin-top: 40px;
        color: #666;
        text-align: center;
    }
</style>

<style lang="scss">
    // fix css style bug in open el-dialog
    .el-popup-parent--hidden {
        .fixed-header {
            padding-right: 15px;
        }
    }
</style>
